import { DlqRedriveInfoApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../../../lusca-search-api/generated-src";

interface ExecuteDlqRedriveParams {
  stage: Stage;
  messageIds?: string[];
  file?: File;
  mcmId?: string;
  dryRun: boolean;
  deleteWithoutRedriving: boolean;
}

export const useExecuteDlqRedrive = () => {
  const uploadFileAndGetUri = async (file: File, stage: Stage) => {
    const dlqRedriveApi = DlqRedriveInfoApiFactory();

    const uploadUrlResponse = await dlqRedriveApi.getDLQRedriveUploadUrl(
      stage,
      file.name
    );

    if (!uploadUrlResponse.data?.uploadUrl || !uploadUrlResponse.data?.s3Uri) {
      throw new Error("Failed to get upload URL");
    }

    const uploadResponse = await fetch(uploadUrlResponse.data.uploadUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": "text/csv",
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload file to S3");
    }

    const etagHeader = uploadResponse.headers.get("ETag");
    const etag = etagHeader?.replace(/"/g, '');

    return {
      s3Uri: uploadUrlResponse.data.s3Uri,
      etag
    };
  };

  const executeRedrive = async ({
    stage,
    messageIds,
    file,
    mcmId,
    dryRun,
    deleteWithoutRedriving
  }: ExecuteDlqRedriveParams) => {
    const dlqRedriveApi = DlqRedriveInfoApiFactory();

    let messageIdsS3Uri: string | undefined;
    let messageIdsS3Etag: string | undefined;

    if (file) {
      const { s3Uri, etag } = await uploadFileAndGetUri(file, stage);
      messageIdsS3Uri = s3Uri;
      messageIdsS3Etag = etag;
    }

    const response = await dlqRedriveApi.postDLQRedriveInfo(stage, {
      messageIds,
      messageIdsS3Uri,
      messageIdsS3Etag,
      mcmId,
      dryRun,
      deleteWithoutRedriving
    });

    return response.data;
  };

  return { executeRedrive };
};
